import React, { useState, useEffect } from 'react';
import { Col, CardBody, Input, Button, FormGroup } from 'reactstrap';
import { toast } from 'react-toastify';
import APIClient from '../../helpers/APIClient';
import Loader from '../../components/Loader';
import { connect } from 'react-redux';
import { baseUrl } from '../../constants/environment';
import { checkRole } from '../../helpers/Roles';
import moment from 'moment';
import Flatpickr from 'react-flatpickr';
import { Vietnamese } from 'flatpickr/dist/l10n/vn';
import styled from 'styled-components';
import NumberFormat from 'react-number-format';
import TextUtils from '../../helpers/TextUtils';
import { cloneDeep } from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import PriceUtils from '../../helpers/PriceUtils';
import { calTotalStockQuantity } from '../product/ProductBatchList';

const BatchDetail = (props: any) => {
    const { closeModal, action, batch_id} = props
    const [loading, setLoading] = useState(false);
    const [batch, setBatch] = useState<any>([]);
    const type = action?.type
    const onlyView = type === 'view'

    useEffect(() => {
        loadData(batch_id)
    }, [batch_id]);

    const loadData = async (id: number) => {
        const url = `${baseUrl}/product-batch/${id}`;
        setLoading(true)
        let response: any = await APIClient.GET(url);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            const resData = response.response;
            setBatch({
                ...resData,
                production_date: resData?.production_date ? moment(resData?.production_date).valueOf() : '',
                expiration_date: resData?.expiration_date ? moment(resData?.expiration_date).valueOf() : '',

            })
        }
    }

    const handleChangeData = (event?: any) => {
        const { value, name } = event.target
        setBatch({
            ...batch,
            [name]: value
        })
    }

    const validationFrom = () => {
        if(!batch?.name){
            toast.warning('Mã lô và số lượng không được để trống!');
            return false
        }
        
        return true
    }
    
    const handleSubmit = async () => {
        if (!validationFrom()) return;
        setLoading(true)
        const url = `${baseUrl}/product-batch/${batch_id}`;
        const params = {
            production_date: batch?.production_date,
            expiration_date: batch?.expiration_date,
        }
        let response: any = await APIClient.PUT(url, params);
        setLoading(false)
        if (response.error !== undefined) {
            toast.error(response.error.error_description)
        } else if (response.response !== undefined) {
            toast.success('Cập nhật lô sản phẩm thành công')
            closeModal()
            props?.loadData();
        }
    }

    if(!checkRole(props?.user?.roles, ['batchAdd', 'batchEdit'], props?.user?.role)){
        return (
            <CardBody className='p-0' style={{width:460}}>
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-action-title">
                        Thông báo
                    </h5>
                    <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
                </div>
                <div className="modal-body pt-2 pb-2">
                    <Col md={12}>
                        <FormGroup row className="label-only">
                            <p className="font-size-14" style={{textAlign: 'center', width:'100%'}}>
                                Bạn không có quyền thực hiện thao tác này
                            </p>
                        </FormGroup>
                    </Col>
                </div>
                <div className="modal-footer">
                    <Button
                        onClick={closeModal}
                        className="ml-2 success-bland" color="success" type="button"
                    > Hủy bỏ</Button>
                </div>
                {loading && <Loader />}
            </CardBody>
    
        )
    }

    const totalStockQuantity = calTotalStockQuantity(batch?.stock_quantity)

    return (
        <CardBody className='p-0' style={{width: 800}}>
            <div className="modal-header">
                <h5 className="modal-title" id="modal-action-title">
                {
                    action?.type === 'edit' ? `Chỉnh sửa lô #${batch?.name}` :
                    action?.type === 'view' ? `Chi tiết lô #${batch?.name}`
                    : "Thông báo"
                }
                </h5>
                <button onClick={()=>closeModal()} type="button" className="close" > <span aria-hidden="true">×</span> </button>
            </div>
            <div className="modal-body pt-0">
                <PageContent className={onlyView ? 'only-view' : ''}>
                    <div className="table-responsive" style={{overflow: 'unset'}}>
                        <table className="mb-0 table-custom no-bg table table-input" >
                            <thead>
                                <tr>
                                    <th className='text-center' style={{ width: '25%' }}>Mã Lô</th>
                                    <th className='text-center' style={{ width: '18%' }}>Ngày sản xuất</th>
                                    <th className='text-center' style={{ width: '18%' }}>Hạn sử dụng</th>
                                    <th className='text-center' style={{ width: '18%' }}>Người tạo</th>
                                    <th className='text-center' style={{ width: '18%' }}>Thời gian tạo</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>
                                    <Input 
                                        type="text" 
                                        value={type === 'view' && !batch?.name ? '---': batch?.name}
                                        // disabled={onlyView} 
                                        disabled={true} 
                                        placeholder={(type=='view' && !batch?.name) ? "---" : "Mã lô"} 
                                        onChange={(e: any) => handleChangeData({ target: { name: 'name', value: e.target.value } })}
                                    />
                                </td>
                                <td>
                                    <Flatpickr
                                        value={[new Date(batch?.production_date)]}
                                        onChange={(date: any) => {
                                            const day = date[0] ? moment(date[0]) : undefined
                                            handleChangeData({ target: { name: 'production_date', value: moment(day).startOf('day').valueOf() } })
                                        }}
                                        options={{
                                            locale: Vietnamese,
                                            allowInput: true,
                                            dateFormat: "d/m/Y",
                                            altInputClass: "date-range",
                                        }}
                                        className="form-control"
                                        placeholder={type ==="view" && !batch?.production_date ? "---": "dd/mm/yyyy" }
                                    />
                                </td>
                                <td>
                                    <Flatpickr
                                        value={[new Date(batch?.expiration_date)]}
                                        onChange={(date: any) => {
                                            const day = date[0] ? moment(date[0]) : undefined
                                            handleChangeData({ target: { name: 'expiration_date', value: moment(day).startOf('day').valueOf() } })
                                        }}
                                        options={{
                                            locale: Vietnamese,
                                            allowInput: true,
                                            dateFormat: "d/m/Y",
                                            altInputClass: "date-range",
                                            minDate: 'today'
                                        }}
                                        className="form-control"
                                        placeholder={type ==="view" && !batch?.expiration_date ? "---": "dd/mm/yyyy" }
                                    />
                                </td>
                                <td>
                                    {batch?.created_uid?.name}
                                </td>
                                <td>
                                    <Flatpickr
                                        value={[new Date(batch?.created_time)]}
                                        onChange={(date: any) => {
                                            const day = date[0] ? moment(date[0]) : undefined
                                            handleChangeData({ target: { name: 'created_time', value: moment(day).startOf('day').valueOf() } })
                                        }}
                                        options={{
                                            locale: Vietnamese,
                                            allowInput: true,
                                            dateFormat: "d/m/Y",
                                            altInputClass: "date-range",
                                            minDate: 'today'
                                        }}
                                        className="form-control"
                                        placeholder={type ==="view" && !batch?.created_time ? "---": "dd/mm/yyyy" }
                                    />
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    {action?.type === 'view' &&
                    <div className="table-responsive" style={{overflow: 'unset'}}>
                        <table className="mb-0 table-custom no-bg table table-input" >
                            <thead>
                                <tr>
                                    <th className='text-left' style={{ width: '25%' }}>Chi nhánh</th>
                                    <th className='text-center' style={{ width: '18%' }}>Tồn kho</th>
                                    <th className='text-center' style={{ width: '18%' }}>Tạm giữ</th>
                                    <th className='text-center' style={{ width: '18%' }}>Đang vận chuyển</th>
                                    <th className='text-center' style={{ width: '18%' }}></th>
                                </tr>
                            </thead>
                            <tbody>
                                {batch?.stock_quantity?.map((item:any, index:number)=>{
                                    
                                    return(
                                        <tr key={`branch-${index}`}>
                                            <td className='text-left'>{item?.branch_id?.name}</td>
                                            <td className='text-center'>{PriceUtils.format(Number(item?.quantity || 0), '')}</td>
                                            <td className='text-center'>---</td>
                                            <td className='text-center'>---</td>
                                            <td className='text-center'>{PriceUtils.format(Number(totalStockQuantity || 0), '')}</td>
                                        </tr>
                                    )
                                })}
                            
                            </tbody>
                        </table>
                    </div>}
                </PageContent>
            </div>
            {action?.type !== 'view' &&
            <div className="modal-footer">
                <Button
                    onClick={()=>{
                        action?.type === 'edit' && handleSubmit()
                    }}
                    className="ml-2" color="success" type="button"
                >{(action?.type === 'add' || action?.type === "addBatch") ? "Lưu": "Xác nhận"}</Button>
            </div>}
            {loading && <Loader />}
        </CardBody>

    )
}

const PageContent = styled.div`
    &.only-view {
        .nutri-form {
            input {
                border:none;
                pointer-events:none;
            }
            .react-select__indicators {
                display:none!important;
            }
            .react-select__control {
                border:none;
                background-color: transparent!important;
            }
        }
    }
`
const ValueText = styled.div`
    min-height: 36px;
    display:flex;
    align-items:center;
`
const customStyles = {
    menuList: (base:any) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto"
    }),
};

const mapState = (state: any) => {
    return {
        user: state.Auth.user,
    };
};

export default connect(mapState)(BatchDetail)